import CONTRATO_FUENTES_FINANCIERAS from '@/graphql/querys/administracion/contratos/contratoFuentesFinancieras.gql';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [mixFormatoEstructura],
  data() {
    return {
      fianzas: [
        { id: 1, nombre: 'cumplimiento' },
        { id: 2, nombre: 'anticipo' },
        { id: 3, nombre: 'viciosocultos' },
        { id: 4, nombre: 'endoso' },
      ],
      tiposFechas: [
        {
          id: 'fecha-de-entrega-de-proyecto',
          name: 'fechaEntregaProyecto',
        },
        {
          id: 'fecha-de-entrega-de-sitio',
          name: 'fechaEntregaSitio',
        },
        {
          id: 'fecha-aviso-de-terminacion',
          name: 'fechaAvisoTerminacion',
        },
        {
          id: 'fecha-de-verificacion-de-los-trabajos',
          name: 'fechaVerificacionTrabajos',
        },
        {
          id: 'fecha-de-recepcion-de-trabajos',
          name: 'fechaRecepcionTrabajos',
        },
        {
          id: 'fecha-de-cierre-de-bitacora',
          name: 'fechaCierreBitacora',
        },
        {
          id: 'fecha-de-acta-finiquito',
          name: 'fechaActaFiniquito',
        },
        {
          id: 'fecha-de-acta-de-extincion',
          name: 'fechaActaExtincion',
        },
        {
          id: 'fecha-de-entrega-de-obra',
          name: 'fechaEntregaObra',
        },
        {
          id: 'fecha-de-suspension-de-trabajos',
          name: 'fechaSuspensionTrabajos',
        },
        {
          id: 'fecha-de-reinicio-de-trabajos',
          name: 'fechaReinicioTrabajos',
        },
        {
          id: 'fecha-solicitud-terminacion-anticipada',
          name: 'fechaSolicitudTerminacionAnticipada',
        },
        {
          id: 'fecha-de-terminacion-anticipada',
          name: 'fechaTerminacionAnticipada',
        },
        {
          id: 'fecha-inicio-de-rescision-administrativa',
          name: 'fechaInicioRescisionAdministrativa',
        },
        {
          id: 'fecha-de-resciscion-administrativa',
          name: 'fechaRescisionAdministrativa',
        },
      ],
    };
  },
  apollo: {
    contratoFuentesFinancieras: {
      query: CONTRATO_FUENTES_FINANCIERAS,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    integraContratoFechas() {
      if (!this.fechas) return [];
      const contratoFechasMap = new Map();
      this.tiposFechas
        .map((tipo) => {
          const fechaTipo = this.fechas
            .filter((fecha) => (fecha.tipo === tipo.id ? fecha.fecha : false));
          if ((tipo.id === 'fecha-de-suspension-de-trabajos'
          || tipo.id === 'fecha-de-reinicio-de-trabajos')) {
            contratoFechasMap.set(tipo.name, fechaTipo);
          } else if (fechaTipo.length > 0) {
            contratoFechasMap.set(tipo.name, fechaTipo[0].fecha);
          } else {
            contratoFechasMap.set(tipo.name, '');
          }
          return true;
        });
      return Object.fromEntries(contratoFechasMap);
    },
    getContratoFuentesFinancieras() {
      if (!this.contratoFuentesFinancieras) return {};
      const obrasFuentesFinancierasConFormato = this.formatoObjeto(this.contratoFuentesFinancieras);
      const fuentes = new Set();
      const numeros = new Set();
      const fechas = new Set();

      obrasFuentesFinancierasConFormato.obras.forEach((contratoObra) => {
        const recursos = contratoObra.obra?.recursosAutorizados || [];
        // Recursos
        recursos.forEach((detalle) => {
          if (detalle.fuenteFinanciera?.nombre) {
            fuentes.add(detalle.fuenteFinanciera.nombre);
          }
          if (detalle.oficioAutorizacion?.numero) {
            numeros.add(detalle.oficioAutorizacion.numero);
          }
          if (detalle.oficioAutorizacion?.fecha_texto) {
            fechas.add(detalle.oficioAutorizacion.fecha_texto);
          }
        });
      });
      // Contratación
      const tiposContratacion = {
        LP: 'LICITACIÓN PÚBLICA',
        LI: 'LICITACIÓN RESTRINGIDA POR INVITACIÓN',
        AD: 'ADJUDICACIÓN DIRECTA',
      };
      const caracteresContratacion = {
        1: 'NACIONAL',
        2: 'ESTATAL',
      };

      const tipoContratacion = this.contratoFuentesFinancieras?.comoSeContrato || '';
      const caracterContratacion = this.contratoFuentesFinancieras?.licitacion?.caracter || '';
      let contratacion = tiposContratacion[tipoContratacion];
      if (tipoContratacion === 'LP' || tipoContratacion === 'LI') {
        contratacion = `${contratacion} ${caracteresContratacion[caracterContratacion]}`;
      }
      // Número Contratación
      let numeroContratacion = '';
      if (tipoContratacion === 'LP' || tipoContratacion === 'LI') {
        numeroContratacion = this.contratoFuentesFinancieras?.licitacion?.numero || '';
      }
      if (tipoContratacion === 'AD') {
        numeroContratacion = this.contratoFuentesFinancieras?.adjudicacionDirecta?.numeroDictamen || '';
      }
      // Datos
      return {
        fuentesFinancieras: Array.from(fuentes).join(', '),
        oficiosNumeros: Array.from(numeros).join(', '),
        oficiosFechas: Array.from(fechas).join(', '),
        tipoContratacion: contratacion,
        numeroContratacion,
      };
    },
  },
  methods: {

    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto, true, true);
    },
    formatoWordContrato(contrato) {
      if (!contrato || typeof (contrato) !== 'object') return {};
      const contratoMap = new Map();
      let buscaFianza = {};
      let residente = '';
      let supervisionExterna = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(contrato)) {
        switch (key) {
          case 'fianzas':
            if (!value) { break; }
            // eslint-disable-next-line no-loop-func
            value.forEach((f) => {
              buscaFianza = this.fianzas.find((tf) => tf.id === f.tipo);
              if (buscaFianza) {
                contratoMap.set(`fianza_${buscaFianza.nombre}`, {
                  fecha: f.fecha,
                  monto: f.monto,
                  nombreAfianzadora: f.nombreAfianzadora,
                  numero: f.numero,
                });
              }
            });

            this.fianzas.forEach((fianza) => {
              if (!contratoMap.has(`fianza_${fianza.nombre}`)) {
                contratoMap.set(`fianza_${fianza.nombre}`, {
                  fecha: '',
                  monto: null,
                  nombreAfianzadora: '',
                  numero: '',
                });
              }
            });

            break;
          case 'anticipos':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  fecha: '',
                  importe: 0,
                  iva: 0,
                  total: 0,
                  porcentaje: 0,
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'convenios':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  tipo: '',
                  numero: '',
                  fecha: '',
                  importe: 0,
                  iva: 0,
                  total: 0,
                  fechaInicio: '',
                  fechaTermino: '',
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'estimaciones':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [
                  {
                    numero: '',
                    fechaDel: '',
                    fechaAl: '',
                    porcentajeIva: 0,
                    importeEstimado: 0,
                    importeRetenido: 0,
                    importeDevuelto: 0,
                    importeNeto: 0,
                    importeAmortizacionAnticipo: 0,
                    importeDeducciones: 0,
                    subtotal: 0,
                    importeIva: 0,
                    totalFactura: 0,
                    importeBonificacion: 0,
                    importeSancion: 0,
                    importeLiquido: 0,
                    bonificacionDetalle: '',
                    esEstimacionFinPrograma: '',
                    esEstimacionFiniquito: '',
                    importeCostoDirecto: 0,
                    importeCostoIndirectos: 0,
                    importeUtilidad: 0,
                    importeCargosAdicionales: 0,
                    importeCostoFinancieroAmortizacionAnticipo: 0,
                    importeCostoFinanciero: 0,
                    suma: 0,
                    ivaSuma: 0,
                    sumaConIva: 0,
                  },
                ]);
              } else {
                // Campos que forman los 3 renglones previos a SUMA
                const camposSuma = [
                  'importeEstimado',
                  'importeCostoFinanciero',
                  'importeCostoFinancieroAmortizacionAnticipo',
                ];

                // Calcula SUMA, IVA SUMA y SUMA C/IVA para cada estimación
                const estimacionesConTotales = value.map((estimacion) => {
                  const suma = Number(
                    camposSuma
                      .reduce((sum, campo) => sum + (Number(estimacion[campo]) || 0), 0)
                      .toFixed(2),
                  );

                  const porcentajeIva = Number(estimacion.porcentajeIva) || 0;
                  const ivaSuma = Number(((suma * porcentajeIva) / 100).toFixed(2));

                  const sumaConIva = Number((suma + ivaSuma).toFixed(2));

                  return {
                    ...estimacion,
                    suma,
                    ivaSuma,
                    sumaConIva,
                  };
                });

                // Recorre el array de estimaciones y suma cada campo
                const camposTotales = [
                  'importeCostoDirecto',
                  'importeCostoIndirectos',
                  'importeUtilidad',
                  'importeCargosAdicionales',
                  'importeCostoFinancieroAmortizacionAnticipo',
                  'importeCostoFinanciero',
                  'importeEstimado',
                  'importeRetenido',
                  'importeDevuelto',
                  'importeNeto',
                  'importeAmortizacionAnticipo',
                  'importeDeducciones',
                  'subtotal',
                  'importeIva',
                  'totalFactura',
                  'importeBonificacion',
                  'importeSancion',
                  'importeLiquido',
                  'suma',
                  'ivaSuma',
                  'sumaConIva',
                ];

                const totalesEstimaciones = camposTotales.reduce((acc, campo) => {
                  acc[campo] = estimacionesConTotales.reduce(
                    (sum, estimacion) => sum + (Number(estimacion[campo]) || 0),
                    0,
                  );
                  return acc;
                }, {});
                contratoMap.set('totalesEstimaciones', totalesEstimaciones);
                contratoMap.set(key, estimacionesConTotales);
              }
            }
            break;
          case 'superintendentes':
            if (Array.isArray(value)) {
              if (value.length === 0) {
                contratoMap.set(key, [{
                  nombreCompleto: '',
                }]);
              } else {
                contratoMap.set(key, value);
              }
            }
            break;
          case 'plazo':
            contratoMap.set(key, `${value}`);
            break;
          case 'responsables':
            residente = value.filter((r) => r.principal === true)[0]
              ? value.filter((r) => r.principal === true).map((r) => r.funcionario?.nombre)[0]
              : '';
            contratoMap.set('residente', residente);
            break;
          case 'contratosRelacionados':
            supervisionExterna = value.filter((c) => c.esSupervisionExterna === true)[0]
              ? value
                .filter((c) => c.esSupervisionExterna === true)
                .map((c) => c.contratoRelacionado?.contratista)[0]
              : null;
            contratoMap.set(
              'supervisionExternaRepresentante',
              supervisionExterna?.nombreRepresentante || '',
            );
            contratoMap.set(
              'supervisionExternaRazonSocial',
              supervisionExterna?.nombreRazonSocial || '',
            );
            break;
          default:
            if (!value && value !== 0) {
              contratoMap.set(key, '');
              break;
            }
            contratoMap.set(key, value);
            break;
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.integraContratoFechas)) {
        contratoMap.set(key, value);
      }
      contratoMap.set('fecOficiosAutorizacion', this.getContratoFuentesFinancieras.oficiosFechas);
      contratoMap.set('numerosOficiosAutorizacion', this.getContratoFuentesFinancieras.oficiosNumeros);
      contratoMap.set('fuentesFinancieras', this.getContratoFuentesFinancieras.fuentesFinancieras);
      contratoMap.set('tipoContratacion', this.getContratoFuentesFinancieras.tipoContratacion);
      contratoMap.set('numeroContratacion', this.getContratoFuentesFinancieras.numeroContratacion);
      return this.formatoObjeto(Object.fromEntries(contratoMap));
    },
  },
};
